<template>
  <div class="shares-page page">
    <div class="shares-page__title-container">
      <h1 class="shares-page__title">Акции</h1>
    </div>
    <div class="shares-page__container">
      <div ref="sharesList" class="shares-page__content">
        <div v-if="showShares" class="shares-page__items">
          <router-link
            :to="{ name: 'share', params: { id: item.id } }"
            v-for="(item, i) in shares.data"
            :key="i"
            class="shares-page__item"
          >
            <ImgComponent class="shares-page__item-img" :head_img="item.head_img" />
            <div class="shares-page__item-info">
              <span v-if="item.date_end" class="shares-page__item-date">
                до {{ item.date_end | formatDate }}
              </span>
              <h3 v-if="item.title" class="shares-page__item-title">{{ item.title }}</h3>
            </div>
          </router-link>
        </div>
        <span v-else>Акции отсутствуют</span>
        <PaginationComponent
          v-if="showPagination"
          :page="page"
          :total="Math.ceil(shares.paginatorInfo.total / first)"
          @change="paginate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "components/Pagination.vue";
import SHARES_PAGE from "@/graphql/pages/SharesPage.graphql";

export default {
  name: "SharesPage",
  async asyncData({ apollo, store }) {
    await apollo.defaultClient
      .query({
        query: SHARES_PAGE,
        variables: {
          first: store.state.isMobile ? 6 : 10,
        },
      })
      .then(({ data }) => {
        store.state.shares_page.shares = data.shares_paginate;
        store.state.categories = data.categories;
        store.state.marketplace = data.marketplace;
        if (data.exchange_rates) store.state.exchange_rates = data.exchange_rates;
      });
  },
  data() {
    return {
      page: 1,
      first: this.$store.state.isMobile ? 6 : 10,
      paginateLoading: false,
    };
  },
  computed: {
    shares() {
      return this.$store.state.shares_page.shares;
    },
    showShares() {
      return this.shares && this.shares.data && this.shares.data.length;
    },
    showPagination() {
      return this.showShares && Math.ceil(this.shares.paginatorInfo.total / this.first) > 1;
    },
    metaTitle() {
      return this.$store.state.pages.find((page) => page.link === 'shares')?.meta_title ?? 'Акции';
    },
    metaDescription() {
      return this.$store.state.pages.find((page) => page.link === 'shares')?.meta_description ?? '';
    },
    metaKeywords() {
      return this.$store.state.pages.find((page) => page.link === 'shares')?.meta_keywords ?? '';
    },
  },
  methods: {
    async paginate(page) {
      if (!this.paginateLoading) {
        this.page = page;
        this.paginateLoading = true;
        await this.load();
        this.scrollUp();
      }
    },
    async load() {
      await this.$apollo.provider.defaultClient
        .query({
          query: SHARES_PAGE,
          variables: {
            page: this.page,
            first: this.first,
          },
        })
        .then(({ data }) => {
          this.paginateLoading = false;
          this.$store.state.shares_page.shares = data.shares_paginate;
          this.$store.state.categories = data.categories;
        })
        .catch(() => {
          this.filterLoading = false;
          this.paginateLoading = false;
        });
    },
    scrollUp() {
      if (window.scrollY > this.$refs.sharesList.offsetTop) {
        window.scrollTo({ top: this.$refs.sharesList.offsetTop });
      }
    },
  },
  components: {
    PaginationComponent,
  },
  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [
        {
          vmid: "keywords",
          name: "keywords",
          content: this.metaKeywords ?? '',
        },
        {
          vmid: "description",
          name: "description",
          content: this.metaDescription ?? '',
        },
        {
          vmid: "og:title",
          name: "og:title",
          content: this.metaTitle,
        },
        {
          vmid: "og:description",
          name: "og:description",
          content: this.metaDescription,
        },
      ],
    }
  },
};
</script>

<style lang="stylus">
.shares-page {
  width 100%
  display grid
  grid-gap 32px
  padding-top 32px
  padding-bottom 48px
  +below(420px) {
    grid-gap 16px
  }

  &__content {
    display grid
    grid-gap 32px
    width 100%
    max-width var(--main_width)
  }

  &__items {
    display grid
    grid-template-columns repeat(2, 1fr)
    grid-gap 24px
    +below(768px) {
      grid-template-columns 1fr
    }
  }

  &__item {
    display grid
    grid-gap 16px
    padding 8px 8px 16px
    color var(--gray-900)

    &-img {
      width 100%
      height 290px
      object-fit cover
      object-position center
      border-radius: var(--main_radius);
    }

    &-info {
      display grid
      grid-gap 4px
    }

    &-date {
      font-weight: 400;
      font-size: 0.875em
      line-height: 20px;
      color: var(--gray-300)
    }

    &-title {
      font-style: normal;
      font-weight: 400;
      font-size: 1.5em
      line-height: 32px;
      margin 0
    }
  }

  &__container {
    display flex
    justify-content center
    padding: 0 15px;
  }

  &__title {
    max-width var(--main_width)
    width 100%
    font-weight: normal;
    font-size: 2.25em;
    line-height: 50px;
    display: flex;
    align-items: center;
    color: var(--body-color);
    margin 0 auto

    &-container {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 15px;
    }
  }
}
</style>
